import classNames from "classnames"
import { Icon } from "web/components"

export default function MapButton({ name, onClick, disabled = false }) {
  const classes = classNames("shadow-altrio-1 bg-white p-1 rounded-md z-10", {
    "cursor-pointer": !disabled,
    "bg-neutral-9": disabled,
  })

  return (
    <div className={classes} onClick={disabled ? undefined : onClick}>
      <Icon width="24px" height="24px" name={name} />
    </div>
  )
}
